import { render, staticRenderFns } from "./CreateAccountStep.vue?vue&type=template&id=ff176ec8&"
import script from "./CreateAccountStep.vue?vue&type=script&lang=js&"
export * from "./CreateAccountStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports